import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { DbUser } from "../../../interfaces";
import { useEffect, useRef, useState } from "react";
import { CustomChip } from "../utils/CustomChip";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "../../../services/axios";
import { FontProxima, FontRoboto } from "../../../styles/Theme";
import { AccessListItem, ClassListItem, generateGtmEvent } from "../../../Helpers";
import { OverflowTypography } from "../utils/OverflowTypography";

const useStyle = makeStyles((theme) => ({
  shareAccessModal: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  modalTitle: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "20px",
  },
  closeButton: {
    color: theme.palette.text.secondary,
  },
  button: {
    padding: "0px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "137px",
    height: "28px",
    boxShadow: "none",
    fontFamily: FontRoboto,
    fontSize: "19px",
    fontWeight: "500",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "137px",
      boxShadow: "none",
      transform: "none",
    },
  },
  selectedMenuItemText: {
    font: "normal normal bold 16px/20px Roboto !important",
    color: "#191919 !important",
  },
  menuItemText: {
    font: "normal normal 500 16px/20px Roboto !important",
  },
  menuPaper: {
    boxShadow: "0px 8px 12px #00000019",
    border: "1px solid #E8E8E8",
    borderRadius: 8,
  },
  menuList: {
    width: 193,
    padding: "12px",
    "& li": {
      color: "#747474",
      fontWeight: "500",
      padding: "8px 12px",
    },
  },
  buttonNo: {
    width: 108,
    padding: 0,
    backgroundColor: "#D8D8D8",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: "#C9C8C8",
    },
  },
  buttonYes: { width: 108, padding: 0 },
  deleteClassRelButton: {
    color: theme.palette.text.secondary,
    fontSize: "1em",
    width: "30px",
    height: "30px",
    marginLeft: "24px",
  },
}));

interface ShareAccessProps {
  title: string;
  currentUser: DbUser;
  existingObservers: AccessListItem[];
  studentClassOptions?: ClassListItem[];
  open: boolean;
  handleClose: () => void;
  assignAccess: (list: any[], selectedClassIds?: string[]) => void;
  accessFor: "class" | "student";
  removeAccess: (id: string) => void;
  schoolId: string;

  loading: boolean;
}

interface AccessListItemsProps {
  teacher: AccessListItem;
  currentUser: DbUser;
  disableSecondaryAction?: boolean;
  removeAccess?: (id: string) => void;
}

const HandleDataLayer = (
  event: string,
  action: string,
  name: string,
  type: string,
  region: string,
  section: string,
  text: string
) => {
  generateGtmEvent({
    event: event,
    action: action,
    name: name,
    type: type,
    region: region,
    section: section,
    text: text,
  });
};
export const AccessListItems = (props: AccessListItemsProps) => {
  const classes = useStyle();
  // const buttonRef = useRef<HTMLButtonElement | null>(null);
  // const [mainMenuOpen, setMainMenuOpen] = useState(false);
  const {
    teacher,
    disableSecondaryAction = false,
    currentUser,
    removeAccess = () => {},
  } = props;

  const observingClassNames = teacher.classDetails?.map(
    (item) => `${item.subject} ${item.period_block}`
  );

  return (
    <ListItem
      sx={{
        padding: `0px ${disableSecondaryAction ? "0px" : "16px"}`,
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        borderRadius: "15px",
      }}
      alignItems="flex-start"
      secondaryAction={
        !disableSecondaryAction && (
          <>
            <IconButton
              disabled={teacher.role !== "Observer"}
              onClick={() => {
                removeAccess(teacher.id);
                // setMainMenuOpen(false);
                HandleDataLayer(
                  "link",
                  "click",
                  "onclick",
                  "internal link",
                  "main content",
                  `${teacher.full_name}`,
                  "remove access"
                );
              }}
              aria-label="delete-observer-access"
              className={classes.deleteClassRelButton}>
              <i className="fa-regular fa-trash"></i>
            </IconButton>
            {/* <Button
              className={classes.button}
              variant="contained"
              size="small"
              disableElevation
              ref={buttonRef}
              onClick={() => {
                teacher.role === "Observer" &&
                  HandleDataLayer(
                    "collapse",
                    "open",
                    "onclick",
                    "click",
                    "main content",
                    `${teacher.full_name}`,
                    "observer button"
                  );
                teacher.role === "Observer" && setMainMenuOpen(true);
              }}>
              {teacher.role}
              {teacher.role === "Observer" && (
                <DownIcon
                  sx={[
                    {
                      transition: (theme) => theme.transitions.create("transform"),
                    },
                    mainMenuOpen && { transform: "rotate(180deg)" },
                  ]}
                />
              )}
            </Button> */}

            {/* <Menu
              anchorEl={buttonRef.current}
              open={mainMenuOpen}
              onClose={() => {
                setMainMenuOpen(false);
                HandleDataLayer(
                  "collapse",
                  "close",
                  "onclick",
                  "click",
                  "main content",
                  `${teacher.full_name}`,
                  "observer button"
                );
              }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              transformOrigin={{ horizontal: "right", vertical: -8 }}
              MenuListProps={{ className: classes.menuList }}
              PaperProps={{ className: classes.menuPaper }}>
              <MenuItem>Remove access</MenuItem>
            </Menu> */}
          </>
        )
      }>
      <ListItemAvatar>
        <Avatar sx={{ backgroundColor: "#E2F7FF", width: "50px", height: "50px" }}>
          <Typography
            component="span"
            variant="body2"
            sx={{ fontWeight: "600", fontFamily: FontProxima, letterSpacing: "normal" }}>
            {teacher.full_name[0] + teacher.full_name[teacher.full_name.indexOf(" ") + 1]}
          </Typography>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        sx={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "8px",
          marginRight: "40px",
        }}
        primary={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography component="span" variant="body1" sx={{ fontWeight: "bold" }}>
              {teacher.full_name} {teacher.id === currentUser.id && "(You)"}
            </Typography>
            <Typography component="span" variant="body1" sx={{ fontWeight: "bold" }}>
              {teacher.role}
            </Typography>
          </Stack>
        }
        secondary={
          <Stack direction="row" justifyContent="flex-start" alignItems="center">
            <Typography
              component="div"
              variant="body2"
              sx={{ marginRight: "100px", flexGrow: 0 }}>
              {teacher.email}
            </Typography>
            <Box sx={{ flexGrow: 1, position: "relative", minWidth: "100px" }}>
              <OverflowTypography
                variant="body2"
                width="100%"
                height="22.8px"
                alignment="right">
                {observingClassNames?.join(", ")}
              </OverflowTypography>
            </Box>
          </Stack>
        }></ListItemText>
    </ListItem>
  );
};

export const ShareAccessModal = (props: ShareAccessProps) => {
  const classes = useStyle();
  const {
    title,
    currentUser,
    existingObservers,
    studentClassOptions,
    open,
    handleClose,
    assignAccess,
    accessFor,
    removeAccess,
    schoolId,
    loading,
  } = props;
  const horiBreakpointSm = useMediaQuery("(max-width:769px)");
  const [observerSelectedList, setObserverSelectedList] = useState<any[]>([]);
  const [secondStep, setSecondStep] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchList, setSearchList] = useState<any[]>([]);
  const [loadingResults, setLoadingResults] = useState(false);
  let textInputRef = useRef<HTMLInputElement | null>(null);
  const [classSelectedList, setClassSelectedList] = useState<string[]>([]);

  useEffect(() => {
    console.log("inti second step", observerSelectedList);
    if (observerSelectedList.length > 0) {
      setSecondStep(true);
    } else {
      setSecondStep(false);
    }
  }, [observerSelectedList]);

  useEffect(() => {
    setLoadingResults(true);
    const fetchTeachers = async () => {
      try {
        let response = await axios.get(
          `/teachers?search=${searchInput}&schoolId=${schoolId}`
        );
        setLoadingResults(false);
        setSearchList(response.data);
      } catch (e) {
        console.log(e);
        setLoadingResults(false);
      }
    };
    const getData = setTimeout(() => {
      if (searchInput.length > 0 && schoolId) {
        generateGtmEvent({
          event: "form",
          action: "click",
          name: "onclick",
          type: "blur",
          region: "main content",
          section: `share "${title}" ^ name or email`,
          text: `${searchInput}`,
        });
        fetchTeachers();
      }
    }, 250);

    return () => clearTimeout(getData);
  }, [title, searchInput, schoolId]);

  const closeModal = () => {
    setSecondStep(false);
    setObserverSelectedList([]);
    setSearchInput("");
    setSearchList([]);
    handleClose();
  };

  const handleToggleClass = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    setClassSelectedList(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <>
      <Modal open={open} onClose={closeModal}>
        <Card
          sx={{ width: horiBreakpointSm ? "600px" : "900px" }}
          className={classes.shareAccessModal}>
          <CardHeader
            sx={{ padding: "0.5rem 24px" }}
            title={
              <Typography
                id="edit-account-modal-title"
                variant="h6"
                className={classes.modalTitle}>
                Share "{title}"
              </Typography>
            }
            avatar={
              secondStep && (
                <Tooltip
                  placement="bottom-end"
                  title="Back"
                  arrow
                  role="tooltip"
                  describeChild>
                  <IconButton
                    onClick={() => {
                      setObserverSelectedList([]);
                      textInputRef.current?.focus();
                      HandleDataLayer(
                        "link",
                        "click",
                        "onclick",
                        "internal link",
                        "main content",
                        `share "${title}"`,
                        "back button"
                      );
                    }}
                    aria-label="Back"
                    className={classes.closeButton}>
                    <ArrowBackIcon />
                  </IconButton>
                </Tooltip>
              )
            }
            action={
              <Tooltip
                placement="bottom-end"
                title="Close"
                arrow
                role="tooltip"
                describeChild>
                <IconButton
                  onClick={() => {
                    closeModal();
                    HandleDataLayer(
                      "modal",
                      "close",
                      "onclick",
                      "click",
                      "main content",
                      `share "${title}"`,
                      "close cross"
                    );
                  }}
                  aria-label="close edit user account"
                  className={classes.closeButton}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            }
          />
          <Divider />
          <CardContent
            sx={{
              padding: `24px 32px ${!secondStep ? "0px" : "32px"} 32px`,
              maxHeight: "450px",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}>
            {!secondStep && (
              <Typography variant="body1" component={"span"}>
                Share {accessFor} progress to a registered Digit user by entering their
                name or email address below and selecting them from the list. This will
                give them observer access. You may remove them at any time.
              </Typography>
            )}
            <Autocomplete
              ref={textInputRef}
              value={observerSelectedList}
              loading={loadingResults}
              onOpen={() => {
                setSearchInput(" ");
              }}
              noOptionsText={"No results found"}
              onChange={(e, value) => {
                if (value.length && value.length > 0) {
                  generateGtmEvent({
                    event: "select",
                    action: "click",
                    name: "onclick",
                    type: "select name or email",
                    region: "main content",
                    section: `share "${title}"`,
                    text: `${[value[0].full_name]}`,
                  });
                }
                setObserverSelectedList(value);
              }}
              onInputChange={(e, value) => {
                setSearchInput(value);
              }}
              multiple
              id="tags-outlined"
              options={searchList}
              getOptionLabel={(option) => option.full_name}
              filterOptions={(options) => {
                if (studentClassOptions && studentClassOptions?.length > 1) {
                  return options;
                } else {
                  return options.filter((option) => {
                    return !existingObservers.find(
                      (observer) => observer.id === option.id
                    );
                  });
                }
              }}
              renderInput={(params) => {
                params.InputProps.endAdornment = null;
                return (
                  <TextField
                    {...params}
                    label="Enter name or email address"
                    placeholder="Enter name or email address"
                    inputRef={(input) => {
                      textInputRef.current = input;
                    }}
                  />
                );
              }}
              renderOption={(props, option, { selected }) => {
                return selected ? null : (
                  <li {...props}>
                    <AccessListItems
                      disableSecondaryAction={true}
                      teacher={option}
                      currentUser={currentUser}
                    />
                  </li>
                );
              }}
              renderTags={(value, getTagProps) => {
                return value.map((option, index) => {
                  return (
                    <CustomChip
                      showAvatar
                      key={`ob-chip-${index}`}
                      label={option.full_name}
                      onClose={(e) => {
                        getTagProps({ index }).onDelete(e);
                        HandleDataLayer(
                          "select",
                          "unclick",
                          "onclick",
                          "checkbox",
                          "main content",
                          `share ${title}`,
                          `${option.full_name}`
                        );
                      }}
                    />
                  );
                });
              }}
            />
            {/* TS Ignore used for this component due to janky Material UI multi-select types */}
            {studentClassOptions && studentClassOptions?.length > 1 && (
              <FormControl>
                <InputLabel id="observer-class-multi-select-label">
                  Select class
                </InputLabel>
                <Select
                  label="Select class"
                  labelId="observer-class-multi-select-label"
                  id="observer-class-multi-select"
                  multiple={true}
                  // @ts-ignore
                  value={classSelectedList}
                  onChange={handleToggleClass}
                  input={<OutlinedInput label="Select class" />}
                  // @ts-ignore
                  renderValue={(selectedIds) => {
                    return selectedIds.map((selectedId) => {
                      const classListItem = studentClassOptions?.find(
                        (item) => item.id === Number(selectedId)
                      );
                      return (
                        <CustomChip
                          key={`ob-class-chip-${selectedId}`}
                          label={`${classListItem?.subject} ${classListItem?.period_block}`}
                        />
                      );
                    });
                  }}>
                  {studentClassOptions?.map((classOption) => (
                    <MenuItem key={classOption.id} value={classOption.id.toString()}>
                      <Checkbox
                        checked={classSelectedList.includes(classOption.id.toString())}
                      />
                      <ListItemText
                        primary={`${classOption.subject} ${classOption.period_block}`}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {!secondStep && (
              <Typography variant="h4" component={"span"}>
                People with access
              </Typography>
            )}
            {!secondStep && <Divider />}
            {!secondStep && (
              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                  maxHeight: "300px",
                  overflow: "auto",
                  paddingTop: "0px !important",
                  "&::-webkit-scrollbar": {
                    width: "0.4em",
                  },
                  "&::-webkit-scrollbar-track": {
                    boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
                    webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "rgba(0,0,0,.1)",
                  },
                }}>
                {loading && (
                  <Box sx={{ width: "100%", textAlign: "center" }}>
                    <CircularProgress />
                  </Box>
                )}
                {!loading &&
                  existingObservers.map((teacher, index) => (
                    <AccessListItems
                      key={`acl-modal-item-${index}`}
                      removeAccess={removeAccess}
                      teacher={teacher}
                      currentUser={currentUser}
                    />
                  ))}
              </List>
            )}
          </CardContent>
          <Divider />
          <CardActions sx={{ padding: "16px 48px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
              }}>
              <Stack direction="row" justifyContent="space-between" gap={4}>
                {secondStep && (
                  <Button
                    onClick={() => {
                      closeModal();
                      HandleDataLayer(
                        "link",
                        "click",
                        "onclick",
                        "internal link",
                        "main content",
                        `share "${title}"`,
                        "cancel"
                      );
                    }}
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.buttonNo}>
                    Cancel
                  </Button>
                )}
                <Button
                  onClick={() => {
                    let classIds;
                    if (studentClassOptions) {
                      if (studentClassOptions.length > 1) {
                        classIds = classSelectedList;
                      } else {
                        classIds = [studentClassOptions[0].id.toString()];
                      }
                    }
                    assignAccess(observerSelectedList, classIds);
                    closeModal();
                    if (!secondStep) {
                      HandleDataLayer(
                        "modal",
                        "close",
                        "onclick",
                        "click",
                        "modal",
                        `share "${title}"`,
                        "Done"
                      );
                    } else {
                      HandleDataLayer(
                        "form",
                        accessFor === "class" ? "sharing a class" : "share_user",
                        "onshare",
                        "share",
                        "main content",
                        `share "${title}"`,
                        `${observerSelectedList
                          .map((observer) => observer.full_name)
                          .join(", ")}`
                      );
                    }
                  }}
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.buttonYes}>
                  {secondStep ? "Share" : "Done"}
                </Button>
              </Stack>
            </Box>
          </CardActions>
        </Card>
      </Modal>
    </>
  );
};
